import { useSyncExternalStore } from "react"
import ChatWidget from "./ChatWidget"
import { chatStore, getInputValue, setInputValueExternal } from "./chatStore"

export const Widget = ChatWidget

export const addResponseMessage = (text) => chatStore.addResponse(text)
export const addUserMessage = (text) => chatStore.addUser(text)
export const renderCustomComponent = (component, props) => chatStore.addCustom(component, props)
export const deleteMessages = () => chatStore.clear()
export const toggleMsgLoader = (value) => chatStore.toggleLoader(value)
export const toggleInputDisabled = (value) => chatStore.toggleInputDisabled(value)
export const markAllAsRead = () => chatStore.markAllAsRead()
export const setInputText = (text) => setInputValueExternal(text)
export const getInputText = () => getInputValue()
export const isWidgetOpened = () => chatStore.getSnapshot().isOpen
export const toggleWidget = (value) => chatStore.toggleOpen(value)

export const useIsWidgetOpen = () =>
  useSyncExternalStore(chatStore.subscribe, () => chatStore.getSnapshot().isOpen)
